import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';
import { ExpandableContainer } from '@unite-us/client-utils';
import { Divider } from '@unite-us/ui';
import {
  getOutcomeData,
  getResolutionAndUpdatedData,
  getClosedDateData,
} from 'common/display/SingleItemDetails/utils/DetailOutcomeLabels';
import { BasicTable } from 'common/tables';
import { useOutcomeNotes } from 'src/components/Notes/queries';
import { crtb2052SaveClosedDate } from 'common/utils/FeatureFlags/flags';

export function DetailOutcome(props) {
  const { item, showClosedDate } = props;
  const updatedAt = _.get(item, 'updated_at');
  const closedDate = _.get(item, 'closed_date');
  const notes = useOutcomeNotes(item);

  return (
    <div className="detail-outcome">
      <div className="row detail-outcome__summary">
        <div className="col-lg-6">
          <BasicTable
            data={getOutcomeData(item)}
            id="outcome-column-one-table"
            type="detail-page"
          />
        </div>
        <div className="col-lg-6 list-divider">
          <BasicTable
            data={getResolutionAndUpdatedData(item, updatedAt)}
            id="outcome-column-two-table"
            type="detail-page"
          />
          {showClosedDate && closedDate && (
            <BasicTable
              data={getClosedDateData(closedDate)}
              id="outcome-column-three-table"
              type="detail-page"
            />
          )}
        </div>
      </div>

      <Divider className="mt-4" />

      <div className="row">
        <div className="col-lg-12">
          <ExpandableContainer
            id="outcome-notes-expandable"
            header="Outcome Notes"
            collapsedHeight="70px"
            style={{ backgroundColor: '#ECF5FD' }}
          >
            <p>
              {_.get(notes, '[0].text', '')}
            </p>
          </ExpandableContainer>
        </div>
      </div>
    </div>
  );
}

DetailOutcome.propTypes = {
  item: PropTypes.shape({
    closed_date: PropTypes.string,
    closing: PropTypes.shape({
      note: PropTypes.string,
      resolved: PropTypes.bool,
      created_by: PropTypes.shape({
        full_name: PropTypes.string,
      }).isRequired,
      outcome: PropTypes.string,
    }).isRequired,
  }).isRequired,
  showClosedDate: PropTypes.bool,
};

DetailOutcome.defaultProps = {
  showClosedDate: false,
};

function mapStateToProps(state) {
  return {
    showClosedDate: crtb2052SaveClosedDate(state),
  };
}

export default connect(mapStateToProps)(DetailOutcome);
